<div class="container">
    <img data-testid="session-ending-progression-pic" [src]="animationUrl" [alt]="altText"/> 
    <div>
        <h3 data-testid="session-ending-progression-header" class="large-font bold">{{ header }}</h3>
        <p data-testid="session-ending-progression-subheader" class="medium-font regular">{{ subHeader }}</p>
    </div>
</div>
